// 商品路由
const name = '設置'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/shopadmin/shopsetting',
  component: Layout,
  children: [
    {
      path: 'staff/Merchantstaff',
      name: `帳號管理-店鋪管理員`,
      component: () => import('@/view/base/account/storestaff')
    },
    {
      path: 'staff/Merchantstaffroles',
      name: `帳號管理-店鋪員工權限`,
      component: () => import('@/view/base/account/storeroles')
    },
    {
      path: 'baseexport',
      name: `匯出列表`,
      component: () => import('@/view/base/exportlog/index')
    },
    {
      path: 'adapay_member',
      name: `開戶管理`,
      component: () => import('@/view/dealer/create_account.vue')
    },
    {
      path: 'adapay_cash_set',
      name: '提現設置',
      component: () => import('@/view/mall/withdraw/withdraw_setting.vue')
    },
    {
      path: 'datapass/apply',
      name: '權限申請',
      component: () => import('@/view/base/encrypt/authAdmin.vue')
    },
    {
      path: 'information',
      name: `訊息場景`,
      component: () => import('@/view/base/setting/information')
    }
  ]
}
